<template>
  <div class="device-plan-library">
    <div class="border_title">
      {{ $t('tianmu.lightLibrary') }}
    </div>
    <div class="device-plan-library-container">
      <el-tabs v-model="type" @change="tabChange">
        <el-tab-pane :label="$t('tianmu.qualityLight')" name="1">
          <Light v-if="type==='1' && device && device.Gpno" :device="device" />
        </el-tab-pane>
        <el-tab-pane label="AI" name="2">
          <AiPic v-if="type==='2' && device && device.Gpno" :device="device" from="feifan" />
        </el-tab-pane>
        <el-tab-pane :label="$t('sceneTemplate.customUpload')" name="3">
          <Upload v-if="type==='3' && device && device.Gpno" :device="device" />
        </el-tab-pane>
      </el-tabs>
      <div class="device-plan-library_hd">
        <OppleButton
          v-if="device.ClassSku !== '0x2907000A'"
          @click="goLink"
        >
          {{ $t('base.redraw') }}
        </OppleButton>
      </div>
    </div>
  </div>
</template>
<script>
import AiPic from './AiPic.vue';
import Light from './Light.vue';
import Upload from './Upload.vue';
import OppleButton from '@/components/Base/OppleButton/index.vue'

export default {
  components: {
    AiPic,
    Light,
    Upload,
    OppleButton
  },
  props: {
    device: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      type: '1'
    }
  },

  watch: {
  },
  mounted() {
  },
  destroyed(){
  },
  methods: {
    goLink() {
      this.$router.push({
        name: 'tianmu',
        params: {
          shapeType: 2,
          checkDeviceList: [this.device],
          from: 'feifan',
          isFeifan: true,
          GpNo: this.gpNo,
          deviceText: '',
          CustomGroups: [],
        }
      });

    },
    tabChange(val) {

    }
  }
}
</script>
<style lang="scss" scoped>
.device-plan-library {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  ::v-deep .el-tabs__content{
    min-height: 500px;
  }
}
.device-plan-library-container {
  padding: 20px;
  border: 2px solid #e1e3e6;
}

.device-plan-library_hd {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
</style>
